import { Component, Input, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';

import { CONFIGURATIONS_ACTION } from '../configurations-detail/configurations-detail.component';

@Component({
  selector: 'app-configurations-template-icon',
  templateUrl: 'configurations-template-icon.component.html',
  styleUrls: ['./configurations-template-icon.component.scss']
})
export class ConfigurationsTemplateIconComponent implements OnInit {
  @ViewChild('scroll') private scroll: ElementRef;

  @Output() onSave = new EventEmitter<any>();
  @Input() data: any;
  @Input('mode') set mode(value: any) {
    this.action = value;
    if (value === CONFIGURATIONS_ACTION.ADD) {
      this.scrollToBottom();
    }
  };
  public actionCheck: any = CONFIGURATIONS_ACTION;
  public action: any = CONFIGURATIONS_ACTION;
  public userInput: string;
  constructor() { }

  ngOnInit() { }

  removeItem(item: any, items: any) {
    const index = items.indexOf(item);
    if (index > -1) {
      items.splice(index, 1);
    }
  }

  addItem(item: any, items: any) {
    if (item) {
      items.push({ icon: item });
      this.userInput = '';
      this.onSave.emit(items);
      this.scrollToBottom();
    }
  }

  scrollToBottom() {
    try {
      setTimeout(() => {
        this.scroll.nativeElement.scrollTop = this.scroll.nativeElement.scrollHeight;
      }, 300);
    } catch (err) { }
  }

}



// WEBPACK FOOTER //
// /ng-app/src/app/configurations/configurations-template-icon/configurations-template-icon.component.ts